import styled from 'styled-components';
import {
  openDetailLink,
  openYoutubeLink,
  openAppDownloadLink,
  isPc,
  openAplLink,
} from '../../utils';
import { ImageUtils } from '../../utils/ImageUtils';
import { mobileQuery } from '../../utils';

const links = [
  {
    icon: ImageUtils.SnsIcon1,
    text: '피망 쇼다운\n앱 다운로드',
    onClick: openAppDownloadLink,
    onlyWeb: true,
  },
  {
    icon: ImageUtils.SnsIcon2,
    text: 'APL\n 공식 페이지',
    onClick: openAplLink,
  },
  {
    icon: ImageUtils.SnsIcon3,
    text: '피망 포커스\n유튜브',
    onClick: openYoutubeLink,
  },
  {
    icon: ImageUtils.SnsIcon4,
    text: '대회\n상세 안내',
    onClick: openDetailLink,
  },
];

export const BottomSns = () => {
  const pc = isPc();
  return (
    <Container>
      {links.map((link, index) => {
        if (!pc && link.onlyWeb) {
          return null;
        }

        return (
          <Link key={index} onClick={link.onClick}>
            <img src={link.icon} alt="" />
            <LinkText>
              {link.text.split('\n').map((line, i) => (
                <span key={i + 'sns'}>
                  {line}
                  {i < link.text.split('\n').length - 1 && <Br />}
                </span>
              ))}
            </LinkText>
          </Link>
        );
      })}
    </Container>
  );
};

const Br = styled.br`
  display: block;

  ${mobileQuery} {
    display: none;
  }

  @media screen and (max-width: 500px) {
    display: block;
  }
`;

const Container = styled.div`
  position: fixed;
  bottom: 0;
  max-width: 1000px;
  width: 100%;
  z-index: 10;
  height: 125px;

  background: rgba(64, 64, 64, 0.5);
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  display: flex;
  ${mobileQuery} {
    height: 79px;
  }
`;

const Link = styled.div`
  height: 100%;
  flex: 1;
  text-align: center;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 15px;

  &:last-child {
    border-right: none;
  }

  img {
    margin-bottom: 5px;
  }

  ${mobileQuery} {
    padding-bottom: 20px;
    img {
      width: 21px;
    }
  }

  @media screen and (max-width: 500px) {
    padding-bottom: 10px;
  }
`;

const LinkText = styled.h4`
  font-weight: 700;
  font-size: 22px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.04em;

  color: rgba(255, 255, 255, 0.8);
  ${mobileQuery} {
    font-size: 12px;
    line-height: 15px;
  }
`;
